"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    default: ()=>RenderMarkers_RenderMarkers
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const external_react_namespaceObject = require("react");
var external_react_default = /*#__PURE__*/ __webpack_require__.n(external_react_namespaceObject);
const ChatbotDataContext_js_namespaceObject = require("../../../context/ChatbotDataContext.js");
const HotelDetailCard_js_namespaceObject = require("../../../HotelComponent/HotelDetailCard.js");
const ChatMessageErrorBoundary_js_namespaceObject = require("../../ErrorBoundary/ChatMessageErrorBoundary.js");
var ChatMessageErrorBoundary_js_default = /*#__PURE__*/ __webpack_require__.n(ChatMessageErrorBoundary_js_namespaceObject);
const Trips_js_namespaceObject = require("../../Trips/Trips.js");
var Trips_js_default = /*#__PURE__*/ __webpack_require__.n(Trips_js_namespaceObject);
const RenderMarkers = ({ markerToDisplay, setMarker })=>{
    const { isMobile } = (0, external_react_namespaceObject.useContext)(ChatbotDataContext_js_namespaceObject.ChatbotDataContext);
    (0, external_react_namespaceObject.useEffect)(()=>{
        if (markerToDisplay?.markerItem?.displayComponentName === 'REALTIME_HOTEL_BOOKING_MARKER') setMarker(null);
    }, [
        markerToDisplay
    ]);
    if (markerToDisplay?.markerItem?.displayComponentName === 'DISPLAY_MY_TRIPS') {
        const { tripsList: trips, hasMoreTrips, deepLinkPrompt, tripHeaderMsg } = markerToDisplay.markerItem.componentProps || {};
        return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
            px: 2,
            py: 4,
            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(ChatMessageErrorBoundary_js_default(), {
                compnentName: "Trips-realtime",
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(Trips_js_default(), {
                    trips: trips,
                    deepLinkPrompt: deepLinkPrompt,
                    tripHeaderMsg: tripHeaderMsg,
                    hasMoreTrips: hasMoreTrips,
                    displayInRealtimeVoice: true
                })
            })
        }, "chat-msg-display-my-trips-marker");
    }
    if (markerToDisplay?.markerItem?.displayComponentName === 'REALTIME_HOTEL_BOOKING_MARKER') window.open(markerToDisplay?.markerItem?.componentProps?.checkoutLink, '_blank');
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
        children: markerToDisplay?.markerItem?.displayComponentName === 'HOTEL_CARDS_MARKER' ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
            px: 2,
            py: "60px",
            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(ChatMessageErrorBoundary_js_default(), {
                compnentName: "HotelDetailCardsMessage-realtime",
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(HotelDetailCard_js_namespaceObject.HotelDetailCardsMessage, {
                    ...markerToDisplay?.markerItem.componentProps,
                    date: new Date(),
                    setChatMessages: function() {},
                    isMobile: isMobile,
                    isShowMoreListingCards: false
                })
            })
        }, "chat-msg-hotel-cards-marker") : null
    });
};
const RenderMarkers_RenderMarkers = /*#__PURE__*/ external_react_default().memo(RenderMarkers);
exports["default"] = __webpack_exports__["default"];
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "default"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
